// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_InventoryCountingTypes } from '@store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupInventoryCountingTypes = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (InventoryCountingTypes?.length === 0) {
      dispatch(Get_InventoryCountingTypes());
    }
  }, []);

  const { InventoryCountingTypes, loading, error } = useSelector(state => state.Lookup);

  const InventoryCountingTypesOPTIONS = InventoryCountingTypes?.map((item, idx) =>
    item.list?.map(list => ({
      label: i18n.language === 'en' ? list.meaning : list.meaning2,
      value: list.lookupCode
    }))
  );

  return { InventoryCountingTypes, InventoryCountingTypesOPTIONS, loading, error };
};

export default useLookupInventoryCountingTypes;
